import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { Button, ValidateCode } from "@/shared/ui";

type Props = {
  address: string;
  onSubmit: () => void;
  code: string;
  onChangeCode: (value: string) => void;
  onSendCode: () => void;
  pending: boolean;
  sendIsPending: boolean;
  error?: string;
  timer?: number;
};

export default function PlayerMenuSettingsSafetyConfirmNewEmail({
  onSubmit,
  code,
  onChangeCode,
  onSendCode,
  pending,
  sendIsPending,
  address,
  error = "",
  timer,
}: Props) {
  return (
    <FocusLock className="contents">
      <form
        className="gap-3 grow flex flex-col h-full"
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit();
        }}
      >
        <ValidateCode
          address={address}
          type={TfaMethod.EMAIL}
          title="Введите PIN-код, отправленный вам почту"
          code={code}
          onCodeChange={onChangeCode}
          onSubmit={onSubmit}
          onSendCode={onSendCode}
          pending={pending}
          error={error}
          sendCodePending={sendIsPending}
          showSubmitButton={false}
          timer={timer}
        />
        <div className="mt-auto grid gap-2.5">
          {!!error && <div className="alert alert--danger">*{error}</div>}
          <Button
            submit
            onSubmit={onSubmit}
            loading={pending}
            disabled={pending || code.length !== 6}
          >
            Изменить Email
          </Button>
        </div>
      </form>
    </FocusLock>
  );
}
